<template>
	<div class="information-page">
		<Head position="absolute" mode="white" :isHaveBack="true" @back="backHead"></Head>
		<!-- 横幅 -->
		<div class="banner">
			<div class="content w1360 animate__animated animate__fadeInUp">
				<div class="heading">政策资讯</div>
				<div class="des">了解碳足迹最新动态</div>
			</div>
		</div>
		<div class="main w1260">
			<div class="tabs">
				<div class="item" :class="{active: type == item.value}" v-for="(item, index) in tabs" :key="index" @click="tabClick(item, index)">{{ item.label }}</div>
			</div>
			<div class="nodata" v-if="!list.length">
				<svg-icon name="nodata2"></svg-icon>
				<div class="txt">暂无数据</div>
			</div>
			<template v-else>
				<div class="list">
					<router-link tag="div" class="list-item-link" :to="{ name: 'informationDetails', query: { id: item.id, type: type, from: 2   } }" v-for="(item, index) in list" :key="item.id">
						<div class="item"  >
							<div class="date">
								<div class="month">{{ $moment(item.createTime).format('MM/DD') }}</div>
								<div class="year">{{ $moment(item.createTime).format('YYYY') }}</div>
							</div>
							<div class="line"></div>
							<div class="content">
								<div class="title ellipsis-1">{{ item.title }}</div>
								<div class="des ellipsis-3">
									{{ item.description }}
								</div>
							</div>
							<div class="arrow">
								<svg-icon name="arrow3"></svg-icon>
								<svg-icon name="arrow4"></svg-icon>
							</div>
						</div>
					</router-link>
				</div>
				<div class="pagination">
					<el-pagination layout="prev, pager, next" :total="total" :page-size="pageSize" :current-page.sync="pageNum" @current-change="paginationCurrentChange"></el-pagination>
				</div>
			</template>
		</div>
		<Foot></Foot>
	</div>
</template>

<script>
import { PolicyList, InformationList } from '@/common/api.js';
import Head from '@/layout/Head/Head.vue';
import Foot from '@/layout/Foot/Foot.vue';
export default {
	name: 'information',
	components: {
		Head,
		Foot,
	},
	data() {
		return {
			// 资讯类型
			tabs: [
				{
					label: '政策文件',
					value: 1
				},
				{
					label: '通知公告',
					value: 2
				}
			],
			// 激活的资讯类型
			type: 1,
			// 页码
			pageNum: 1,
			// 每页数量
			pageSize: 10,
			// 总数
			total: 0,
			// 搜索文字
			title: '',
			titleTmp: '',
			// 资讯列表
			list: []
		};
	},
	created() {
		console.log('created');
		if (this.$route.query && this.$route.query.type !== undefined) {
			this.type = this.$route.query.type;
		}
		this.getList()
	},
	activated() {
		console.log('activated');
	},
	methods: {
		backHead() {
			this.$router.push({ name: 'home' });
		},
		// 切换类型
		tabClick(item, index) {
			if (this.type == item.value) {
				return;
			}
			this.type = item.value;
			this.pageNum = 1;
			this.getList()
		},
		//获取政策列表
		getPolicyList() {
			let data = {
				pageNum: this.pageNum,
				pageSize: this.pageSize,
				releaseState: 1,
				itemCode: '',
				year: ''
			};
			PolicyList(data).then((res) => {
				this.list = res.data;
				this.total = res.total;
			});
		},
		//获取资讯列表
		getInformationList() {
			let data = {
				pageNum: this.pageNum,
				pageSize: this.pageSize,
				releaseState: 1,
				title: '',
				itemCode: ''
			};
			InformationList(data).then((res) => {
				this.list = res.data;
				this.total = res.total;
			});
		},
		paginationCurrentChange() {
			this.$bus.$emit('backTop');
			this.getList()
		},
		getList() {
			if (this.type == 1) {
				this.getPolicyList();
			} else if (this.type == 2) {
				this.getInformationList();
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.information-page {
	position: relative;
	display: flex;
	flex-direction: column;
	min-height: 100vh;
	.banner {
		// margin-top: -$head-height;
		background-image: url('~@/assets/tmp/034.png');
		background-size: cover;
		height: 334px;
		.content {
			display: flex;
			flex-direction: column;
			padding-left: 50px;
			box-sizing: border-box;
			.heading {
				margin-top: 143px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 40px;
				color: #ffffff;
				line-height: 56px;
			}
			.des {
				margin-top: 24px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 22px;
				color: #ffffff;
				line-height: 30px;
				letter-spacing: 6px;
			}
		}
	}
	.main {
		display: flex;
		flex-direction: column;
		padding-top: 48px;
		.tabs {
			display: flex;
			.item {
				margin: 0 30px;
				width: 160px;
				height: 50px;
				background: #f4f4f4;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 18px;
				color: #333333;
				line-height: 50px;
				text-align: center;
				cursor: pointer;
				// &:hover {
				// 	border-color: $primary;
				// 	background-color: $primary;
				// 	color: #ffffff;
				// }
				&:active {
					background-color: #d6d6d6;
				}
				&.active {
					background-color: $primary;
					color: #ffffff;
					&:active {
						background-color: $primary-dark;
					}
				}
			}
		}
		.list {
			margin-top: 70px;
			display: flex;
			flex-direction: column;
			.item {
				padding: 30px 0;
				display: flex;
				border-bottom: 1px dashed #cccccc;
				cursor: pointer;
				transition: all 0.3s ease;
				&:hover {
					background: #f5f5f5;
					.content {
						.title {
							color: #29965c;
						}
					}
					.arrow {
						.svg-arrow3 {
							display: none;
						}
						.svg-arrow4 {
							display: inline;
						}
					}
				}
				.date {
					display: flex;
					flex-direction: column;
					justify-content: center;
					width: 123px;
					padding-left: 38px;
					box-sizing: border-box;
					.month {
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 24px;
						color: #666666;
						line-height: 32px;
					}
					.year {
						margin-top: 2px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 16px;
						color: #808080;
						line-height: 21px;
					}
				}
				.line {
					width: 1px;
					min-height: 150px;
					background: #d9d9d9;
				}
				.content {
					flex: 1;
					padding: 0 30px;
					display: flex;
					flex-direction: column;
					.title {
						margin-top: 15px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 18px;
						color: #333333;
						line-height: 25px;
					}
					.des {
						margin-top: 15px;
						width: 678px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 14px;
						color: #666666;
						line-height: 20px;
						text-align: justify;
					}
				}
				.arrow {
					width: 110px;
					display: flex;
					align-items: center;
					.svg-arrow3 {
						display: inline;
						width: 40px;
						height: 40px;
					}
					.svg-arrow4 {
						margin-left: 20px;
						display: none;
						width: 40px;
						height: 40px;
					}
				}
			}
		}
		.pagination {
			display: flex;
			justify-content: center;
			align-items: center;
			height: 100px;
		}
	}
}
</style>
<style lang="scss" scoped>
.nodata {
	// position: absolute;
	// top: 0;
	// right: 0;
	// left: 0;
	margin-top: 50px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	.svg-icon {
		width: 91px;
		height: 57px;
	}
	.txt {
		margin-top: 23px;
		font-size: 12px;
		color: #cacaca;
		line-height: 17px;
	}
}
</style>
